import { types } from './actions';

const initialState = {
  error: null,
  isSigningUp: false,
  previousSignUpEmail: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SIGN_UP_REQUEST:
      return {
        ...state,
        isSigningUp: true,
      };
    case types.SIGN_UP_SUCCESS:
      return {
        ...state,
        previousSignUpEmail: action.payload.email,
        isSigningUp: false,
        error: null,
      };
    case types.SIGN_UP_ERROR:
      return {
        ...state,
        isSigningUp: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
